import { gql } from "@apollo/client";
import {
  ChapterEntity,
  InitiativeWithProgressOutput,
  LearnerDetailsOutput,
  RefdocCountOutput,
} from "../../generated/graphql";

export const GET_INITIATIVES_AND_REFDOCS = gql`
  query GetInitiativesAndRefdocsForHome2 {
    getLearnerDetails {
      id
      first_name
      last_name
      user_id_state
      ownedcompanies
      avatar_url
      login_cds
      login_skyview
      is_admin
      is_superadmin
      is_doctor
    }
    getInitiativesForLearnerWithProgress {
      unit {
        id
        name
        parent_unit
        is_private
        reassigned_display_name
        intro
      }
      questionCount
      seen_intro
      progress
      isLastActiveInitiative
      assignmentDate
    }
    getReferenceDocumentsForLearner {
      id
      chapter_name
      refdocs {
        id
        document_name
        is_hidden_in_ih
        url
        reftype
      }
    }
    getRefdocViewCount {
      document_id
      count
    }
  }
`;

export interface GetInitiativesAndRefdocsData {
  getLearnerDetails: LearnerDetailsOutput;
  getInitiativesForLearnerWithProgress: InitiativeWithProgressOutput[];
  getReferenceDocumentsForLearner: ChapterEntity[];
  getRefdocViewCount: RefdocCountOutput[];
}
